export const aboutData = {
    title: "Who I am",
    description1: "My name is Devesh Verma ",
    description2: "As a Full-Stack Developer , I create innovative and user-friendly websites and applications for various clients using the MERN Stack, which combines MongoDB, Express, React, and Node.js. I have been working there for over two years and have built several web projects, such as a social media platform, an e-commerce site, and a blog, featuring authentication, payment integration, and dynamic rendering.",
    image: 1
}